/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Integration_Scope_Point_1Inputs */

const en_svc_integration_scope_point_1 = /** @type {(inputs: Svc_Integration_Scope_Point_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI document processing for invoices, orders and forms`)
};

const lv_svc_integration_scope_point_1 = /** @type {(inputs: Svc_Integration_Scope_Point_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI dokumentu apstrāde rēķiniem, pasūtījumiem un veidlapām`)
};

/**
* | output |
* | --- |
* | "AI document processing for invoices, orders and forms" |
*
* @param {Svc_Integration_Scope_Point_1Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_integration_scope_point_1 = /** @type {((inputs?: Svc_Integration_Scope_Point_1Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Integration_Scope_Point_1Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_integration_scope_point_1(inputs)
	return en_svc_integration_scope_point_1(inputs)
});